/**
 * @file 组件初始化入口
 */

import TDropdown from './dropdown.vue'

TDropdown.install = Vue => {
  Vue.component(TDropdown.name, TDropdown)
}

export {
  TDropdown
}



// WEBPACK FOOTER //
// ./src/module/dropdown/index.js